
(function(template){
define('vue!optionalClassProgram/components/helperComponents/checkbox',['Vue'],function(Vue){
    return {
        template: template,
        data: function(){
            return {
                checked: false,
                haveGuests: false
            }
        },
        props: ['selected','item','parentCascade','userId','partiallyGrouped','cascadeCheckbox'],
        methods: {
            handleKeyDown: function(e){
                this.a11yKeyDown(e,{
                    enter: function() {
                        e.target.click();
                    },
                    space: function() {
                        e.target.click();
                    }
                })
            },
            handleClick: function(e){
                e.stopPropagation();
                this.checked = !!this.selected
                this.$emit('handle-checkbox-click',this.checked,this.item,this.parentCascade,this.cascadeCheckbox,this.partiallyGrouped)
            }
        }

    }
})
})('<div role="checkbox" aria-checked="false" aria-label="Checkbox" class=\'custom-check-box\' tabindex="0" @keydown="handleKeyDown" @click="handleClick"> <i v-if="!!selected " class="fas fa-check"></i><i v-if="cascadeCheckbox && partiallyGrouped " class="fas fa-minus"></i></div>');
